import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiDrawer, { drawerClasses } from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";

import MenuContent from "./menu-content.component";
import logo from "../images/logo-with-caption.webp";
import { useNavigate } from "react-router-dom";

const drawerWidth = 280;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: "border-box",
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: "border-box",
  },
});

const SideMenu = () => {
  const navigate = useNavigate();

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: "none", md: "block" },
        [`& .${drawerClasses.paper}`]: {
          background:
            "linear-gradient(0deg, rgba(18, 24, 31, 0.6) 0px, rgba(18, 24, 31, 0.6) 100%), radial-gradient(239.11% 136.81% at 6.64% 0px, rgb(1, 72, 71) 0px, rgb(27, 32, 91) 42.5%, rgb(14, 17, 47) 100%)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "left",
          cursor: "pointer",
          mt: "calc(var(--template-frame-height, 0px) + 4px)",
          p: 1.5,
        }}
      >
        <img
          onClick={() => navigate("/")}
          src={logo}
          alt="Logo"
          style={{ height: "40px", marginLeft: "10px", marginTop: "20px" }}
        />
      </Box>
      <Divider />
      <MenuContent />
    </Drawer>
  );
};

export default SideMenu;
